import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const CollaborationProfile = ({userId, profileId}) => {
    return (
        <div className="profile-container">
            <h1> {userId} and {profileId} </h1>
        </div>
    );
};

export default CollaborationProfile;